import { FaDiscord, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { LuExternalLink } from "react-icons/lu";
import termsOfService from "../../../assets/terms_of_service.md?raw";
import { SOCIALS_CONFIG } from "../../../config/socials_config";
import { usePrivacyTermsModal } from "../../../providers/PrivacyTermsModalProvider";

const contactOptions = [
  {
    title: "Email Support",
    description: (
      <>
        <div className="mb-2">
          <br />
          Available for Grow plan users and above.
          <br />
          Covers platform-related issues only; coding and prompt-engineering
          assistance are not included.
        </div>
        Emails us at:{" "}
        <a
          href="mailto:support@darvin.dev"
          className="text-primary-blue dark:text-blue-400 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          support@darvin.dev{" "}
          <LuExternalLink className="inline ml-1" size={16} />
        </a>
      </>
    ),
  },
];

export default function PersonalSettingsContact() {
  const { show: showPrivacyTermsModal } = usePrivacyTermsModal();

  return (
    <div className="space-y-4">
      {contactOptions.map((option) => (
        <ContactOption key={option.title} option={option} isLast={false} />
      ))}

      {/* Social Media Links */}
      <div className="space-y-4">
        <div className="flex items-center gap-6 text-light-text dark:text-dark-text">
          <a
            href="https://discord.gg/Qkn5JfZMDN"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-70 transition-opacity"
          >
            <FaDiscord className="w-6 h-6" />
          </a>
          <a
            href={SOCIALS_CONFIG.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-70 transition-opacity"
          >
            <FaLinkedin className="w-6 h-6" />
          </a>
          <a
            href={SOCIALS_CONFIG.x}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-70 transition-opacity"
          >
            <FaXTwitter className="w-6 h-6" />
          </a>
        </div>
        <hr className="border-[#8B8B8B4D]" />
      </div>

      <ContactOption
        key={"Terms of Service"}
        option={{
          title: "Terms of Service",
        }}
        isLast={true}
        onClick={() => {
          showPrivacyTermsModal(termsOfService);
        }}
      />
    </div>
  );
}

function ContactOption({
  option,
  isLast,
  onClick,
}: {
  option: {
    icon?: React.ReactNode;
    title: string;
    link?: string;
    description?: React.ReactNode;
  };
  isLast: boolean;
  onClick?: () => void;
}) {
  return (
    <div key={option.title} className="space-y-4">
      <div
        className="text-light-text dark:text-dark-text"
      >
        <div className="font-medium flex items-center gap-1">
          {option.link ? (
            <a
              href={option.link}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline flex items-center gap-1"
            >
              {option.title}
              <LuExternalLink size={16} className="ml-1" />
            </a>
          ) : (
            <button className="hover:underline" onClick={onClick}>
              {option.title}
            </button>
          )}
        </div>
        {option.description && (
          <div className="font-[300]">{option.description}</div>
        )}
      </div>
      {!isLast && <hr className="border-[#8B8B8B4D]" />}
    </div>
  );
}
